
import MakePropsEnumerable from "../../utility/MakePropsEnumerable";

const mIsDownloaded = new WeakMap();
const mReportData = new WeakMap();
const mDecodedReport = new WeakMap();

class CachedTrackingEventReport {
    constructor() {
        mIsDownloaded.set(this, false);
        mReportData.set(this, null);
        mDecodedReport.set(this, null);
    }

    get downloaded() {
        return mIsDownloaded.get(this);
    }

    set downloaded(updatedVal) {
        mIsDownloaded.set(this, (updatedVal === true));
    }

    get reportData() {
        return mReportData.get(this);
    }

    set reportData(updatedReportData) {
        mReportData.set(this, updatedReportData);
    }

    get decodedReport() {
        return mDecodedReport.get(this);
    }

    set decodedReport(updatedData) {
        mDecodedReport.set(this, updatedData);
    }

    resetCachedData() {
        mIsDownloaded.set(this, false);
        mReportData.set(this, null);
        mDecodedReport.set(this, null);
    }
}

MakePropsEnumerable(CachedTrackingEventReport.prototype, [
    "downloaded",
    "reportData",
    "decodedReport"
]);

export default CachedTrackingEventReport;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-editor/CachedTrackingEventReport.js
// module id = tAHV
// module chunks = 1